import hasRole from './hasRole'
import hasPermi from './hasPermi'
import lacksPermi from './lacksPermi'

const install = function (Vue) {
  window.$vueApp.directive('hasRole', hasRole)
  window.$vueApp.directive('hasPermi', hasPermi)
  window.$vueApp.directive('lacksPermi', lacksPermi)
}

if (window.Vue) {
  window['hasRole'] = hasRole
  window['hasPermi'] = hasPermi
  window['lacksPermi'] = lacksPermi
  window.$vueApp.use(install) // eslint-disable-line
}

export default install
